import _find from 'lodash/find';
import {
    GET_CRITEO_PRODUCTS_SUCCESS,
    GET_CRITEO_PRODUCTS_ERROR,
} from '../actionTypes/CriteoActionTypes';
import { parseURL } from '../utils';

const getImageId = (color, attr) => {
    try {
        if ((attr && color[attr] && color[attr].url) || color.url) {
            const url = attr ? parseURL(color[attr].url) : parseURL(color.url);
            return url.pathname.substring(url.pathname.lastIndexOf('/') + 1, url.pathname.length);
        }
        return '';
    } catch (e) {
        return '';
    }
};

const prepareCriteoData = cretioZone => cretioZone.products.map((item) => { //eslint-disable-line
        const data = {};
        if (item.images && item.images.length) {
            const primary = _find(item.images, { type: 'PRIMARY' });
            const alternate = _find(item.images, { type: 'ALTERNATE' });
            data.imagesInfo = {
                altThumbnailImageId: (alternate && getImageId(alternate)) || alternate,
                thumbnailImageId: (primary && getImageId(primary)) || primary,
            };
        }

        const skuSwatch = [];
        if (item.dimensions) {
            const colorSwatches = _find(item.dimensions, { id: 'COLOR' });
            if (colorSwatches && colorSwatches.options) {
                colorSwatches.options.forEach((color, index) => {
                    const swatch = {};
                    swatch.colorName = color.value || '';
                    swatch.colorSeqNum = index;
                    swatch.colorizedImageId = getImageId(color, 'productImage');
                    swatch.defaultSwatch = index === 0;
                    swatch.swatchImageId = getImageId(color, 'image');
                    skuSwatch.push(swatch);
                });
            }
            data.skuSwatch = skuSwatch;
        }

        data.averageRating = (item.valuation && item.valuation.rating) || 0;
        data.reviewCount =
            (item.valuation && item.valuation.reviews && item.valuation.reviews.count) || 0;
        data.priceDetails = _find(cretioZone.prices, { id: item.id });
        data.linkURL = item.ppUrl || '';
        data.pdpUrl = item.ppUrl || '';
        data.isCriteoProduct = true;
        data.beacon = cretioZone.beacons[item.id] || {};
        data.skuId = data.beacon.ProductSKU || '';
        data.ppId = item.id;
        return { ...item, ...data };
    });

export default function CriteoZoneReducer(state = null, action) {
    // NOSONAR
    switch (action.type) {
        case GET_CRITEO_PRODUCTS_SUCCESS:
            return action.cretioZone && action.cretioZone.products
                ? prepareCriteoData(action.cretioZone)
                : [];
        case GET_CRITEO_PRODUCTS_ERROR:
            return null;
        default:
            return state;
    }
}
